module.exports = __webpack_public_path__ + "static/media/steampodProfessional.e64812a2.png";